import React from "react";
import { useAvelaToast } from "src/hooks/useAvelaToast";
import { useOrganization } from "src/hooks/useOrganization";
import { useRefreshUnreadFormActivities } from "../activity/useUnreadFormActivities";
import {
  BulkActionProgressToastInput,
  BulkActionProgressToastPoller,
} from "./BulkActionProgressToast";
import { useInvalidateFormList } from "./useFormsList";

export function useBulkActionProgressToast() {
  const toast = useAvelaToast();
  const organization = useOrganization();
  const refreshUnreadActivities = useRefreshUnreadFormActivities();
  const invalidateFormList = useInvalidateFormList();

  return React.useCallback(
    (input: BulkActionProgressToastInput) => {
      if (!organization.hasData()) {
        return;
      }

      const listLocation = `${window.location.pathname}${window.location.search}`;
      toast({
        duration: null,
        isClosable: true,
        render: ({ onClose }) => (
          <BulkActionProgressToastPoller
            {...input}
            organization={organization.data}
            onClose={onClose}
            onComplete={() => {
              void refreshUnreadActivities(input.formTemplateId);
              const currentLocation = `${window.location.pathname}${window.location.search}`;
              if (currentLocation === listLocation) {
                invalidateFormList();
              }
            }}
          />
        ),
      });
    },
    [invalidateFormList, organization, refreshUnreadActivities, toast]
  );
}
